
const newsletter__modal = document.getElementById("customNewsletter");
const newsletter__close = document.getElementById("customNewsletter__close");

// Open the popup (example trigger)
function openNewsletterPopup() {
  newsletter__modal.style.display = "block";
  document.body.classList.add("no-scroll");
}

// Close the popup
newsletter__close.addEventListener("click", () => {
  newsletter__modal.style.display = "none";
  document.body.classList.remove("no-scroll");
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;

  if (currentUrl.includes('?customer_posted=true#contact_form')) {
    window.location.href = '/pages/thank-you'; // 👈 Change to your actual thank-you page URL
  }
});
